import { Injectable } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { IHttpResponseContract, ISapResponseContractCondition } from '@shared-interfaces/api';
import { IExtDocument } from '@shared-interfaces/documents';

import { IModalComponentName, ModalComponent } from '../components/modal/modal.component';
import { ContractHandler } from '../scripts/contracts';
import { CostCenterHandler } from '../scripts/costCenter';
import { DateHandler } from '../scripts/date';
import { ExtDocument } from '../scripts/extDocument';
import { getStaticData } from '../scripts/staticData';
import { TimesheetHandler } from '../scripts/timesheet';
import { ApiService } from './api.service';
import { MessageService } from './message.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class DatahubService {
  public staticData = getStaticData(this.apiService);

  public contract: ContractHandler;
  public costCenter: CostCenterHandler;
  public timesheet: TimesheetHandler;
  public date: DateHandler;
  public extDocument: ExtDocument;

  constructor(
    public readonly fb: NonNullableFormBuilder,
    public readonly apiService: ApiService,
    public readonly userService: UserService,
    public readonly messageService: MessageService,
    private readonly dialog: MatDialog,
    private readonly router: Router,
  ) {
    this.costCenter = new CostCenterHandler(this.fb, this.userService, this.apiService);
    this.timesheet = new TimesheetHandler(this, this.dialog);
    this.contract = new ContractHandler(this);
    this.date = new DateHandler();
    this.extDocument = new ExtDocument({}, this.contract);
  }

  public launchResponsiveModal(
    component: IModalComponentName,
    data?: any,
    config?: MatDialogConfig,
  ): MatDialogRef<ModalComponent> {
    return this.dialog.open(ModalComponent, {
      data: { component, data },
      ...config,
    });
  }

  public navigate(url: string): void {
    void this.router.navigateByUrl(url);
  }

  public resetApplicationState(msg?: string, isError?: boolean): void {
    this.navigate('/contract');
    this.timesheet.reset();
    this.date.setToNow();
    if (msg) {
      if (isError) this.messageService.error(msg);
      else this.messageService.warning(msg);
    }
  }

  public setContractAndExtDocument(
    contract: IHttpResponseContract,
    condition: ISapResponseContractCondition,
    extDocument: IExtDocument,
  ) {
    this.contract = new ContractHandler(this);
    this.contract.setValue(contract, condition);
    this.extDocument = new ExtDocument(extDocument, this.contract);
  }
}
